import React from 'react';
import { Panel } from "primereact/panel";
import { Accordion, AccordionTab } from 'primereact/accordion';
import * as generic from '../../../../components/Generico';
import { InformacionLaboral } from "../../../../components/trust/InformacionLaboral";
import { BienInmueble } from "../../../../components/trust/BienInmueble";
import { MuebleVehiculo } from "../../../../components/trust/MuebleVehiculo";
import { OtroBienMueble } from "../../../../components/trust/OtroBienMueble";
import { BottomActionBar } from "../../../../components/ui/BottomActionBar";

export const LaboralEconomica = ({ toast, id, permss, catalogos, soloLectura, handlePrev, handleNext }) => {

    return (
        <>
            <Panel header={generic.renderPanelHeader('5', 'DATOS LABORALES', 'pi pi-briefcase')} className="panel-ficha shadow-2 mb-4">
                <div className="p-3">
                    <InformacionLaboral id={id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                </div>
            </Panel>
            <Panel header={generic.renderPanelHeader('6', 'SITUACIÓN ECONÓMICA: ACTIVOS FÍSICOS', 'pi pi-building')} className="panel-ficha shadow-2 mb-4">
                <div className="p-3">
                    <div className="bg-blue-50 p-3 border-round border-1 border-blue-200 mb-4 flex align-items-center gap-3">
                        <i className="pi pi-info-circle text-blue-500 text-xl"></i>
                        <p className="m-0 text-blue-800 text-sm">
                            Registre a continuación los bienes patrimoniales tangibles. <b>Haga clic en cada sección para expandirla.</b>
                        </p>
                    </div>
                    <Accordion multiple activeIndex={[0]}>

                        <AccordionTab header={<span className="flex align-items-center gap-2"><i className="pi pi-home text-blue-600"></i> 6.1.1 Bienes Inmuebles</span>}>
                            <BienInmueble id={id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                        </AccordionTab>

                        <AccordionTab header={<span className="flex align-items-center gap-2"><i className="pi pi-car text-blue-600"></i> 6.1.2.1 Vehículos</span>}>
                            <MuebleVehiculo id={id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                        </AccordionTab>

                        <AccordionTab header={<span className="flex align-items-center gap-2"><i className="pi pi-box text-blue-600"></i> 6.1.2.2 Otros Bienes Muebles</span>}>
                            <OtroBienMueble id={id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                        </AccordionTab>

                    </Accordion>
                </div>
            </Panel>

            <BottomActionBar layoutVersion="v2" onPrev={handlePrev} onNext={handleNext} isReadOnly={true} />
        </>
    );
}
